// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"723edb39","453":"7179d925"}[chunkId] + ".chunk.js";
};